export { default as BlogPost } from 'containers/blog/post';
